import { observer } from "mobx-react";
import FontBody3 from "../../../components/fonts/font-body3/font-body3";
import ShopsSelectorStore from "../shops-selector-store";
import ShopLabel from "../shop-label/shop-label";

interface ISelectDropdownProps {
    store: ShopsSelectorStore;
}

const ShopSelectorInput: React.FC<ISelectDropdownProps> = observer(({ store }) => {
    const fetchedShops =  store.fetchedShops;

    if (!fetchedShops.length) {
        return null;
    }

    return (
        <div className="shops-select-dropdown">
            {
                fetchedShops.map(shop => {
                    return (
                        <div
                            className="shops-select-dropdown-item"
                            onClick={(shop.isSelectable) ? () => store.select(shop) : undefined}
                            key={shop.id}
                        >
                            <ShopLabel shop={shop} />
                            {shop.tag && <FontBody3> {shop.tag}</FontBody3>}
                        </div>
                    );
                })
            }
        </div>
    );
});

export default ShopSelectorInput;
